import React from 'react';
import { DisplayLink } from '@xo-union/tk-ui-links';
import styles from './QuestionSubText.scss';

interface Props {
  privateRsvp: boolean | null;
  hasQuestions: boolean;
  guestCount?: number;
  eventName?: string;
  eventLink?: string;
}

const QuestionSubText: React.FC<Props> = ({ guestCount, hasQuestions, eventName, privateRsvp, eventLink }) => {
  const isEvent = !!eventName && !!eventLink && (!!guestCount || guestCount === 0);

  if (isEvent) {
    if (privateRsvp && guestCount === 0) {
      return (
        <span className={styles.questionSubtext}>
          Heads up! There are <span className={styles.noGuests}>0 guests</span> on your {eventName} list.
        </span>
      );
    } else if (privateRsvp) {
      // If there are guests, and RSVP is private
      return (
        <span className={styles.questionSubtext}>
          Add questions that all {guestCount} guests on your{' '}
          <DisplayLink as="a" href={eventLink} className={styles.displayLink}>
            {eventName}
          </DisplayLink>{' '}
          list will see when they RSVP &quot;Yes!&quot; on your Website.
        </span>
      );
    } else if (!privateRsvp) {
      // If event and RSVP is public.
      return (
        <span className={styles.questionSubtext}>
          Add questions that anyone who RSVPs &quot;Yes!&quot; on your Website will see.
        </span>
      );
    }
  } else if (!isEvent) {
    if (!hasQuestions) {
      return (
        <span className={styles.questionSubtext}>
          Add questions that will be asked to all guests that RSVP, regardless of if they say &apos;Yes&apos; or
          &apos;No&apos;
        </span>
      );
    } else if (hasQuestions) {
      // If no event (for general guest wedding questions)
      return (
        <span className={styles.questionSubtext}>
          These questions will be asked to all guests that RSVP, regardless of if they say &apos;Yes&apos; or
          &apos;No&apos;
        </span>
      );
    }
  }

  return null;
};

export default QuestionSubText;
